class BenefitDeletedSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefitName = systemNotificationPayloadData.benefit_name || "";
  }
}

export default BenefitDeletedSystemNotificationPayload;
